import React, { useEffect, useRef } from 'react';
import successgif from '../../assets/gif/successfullgif.gif';
import print from '../../assets/icons/print.svg';
import close from '../../assets/icons/close.svg';
import { formatDateDDMMYYYY, formatDateDDMMYYYYHHMMSS } from '../../Utils/data&dateTime';
import { useFocusTrap } from '../../Utils/TabIndexingFocus';
import Notifier from '../../Utils/notify';

const formatDateTime = (isoString) => {
    if (!isoString) return '-';
    const d = new Date(isoString);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
};


export const SuccessfulModalPayment = ({ mainheading, submitclose, paymentResponse, onClose, isOpen }) => {


    const printRef = useRef();
    const trapRef = useFocusTrap(isOpen);


    const getCollegeTitle = (courseName) => {
        if (!courseName) return "Banaras Institute of Teachers Education";

        const name = courseName.toLowerCase();

        if (
            name.includes("d pharm") ||
            name.includes("d. pharm") ||
            name.includes("dpharm")
        ) {
            return "Banaras Institute of Pharmacy";
        }

        return "Banaras Institute of Teachers Education";
    };
    const handlePrintReceipt = () => {
        const receiptHtml = `
      <html>
      <head>
        <title>Payment Receipt</title>
        <style>
         
     
             @media print {
            @page {
             size: 58mm auto;
            margin: 0;
            }
            body {
              margin: 0;
            padding: 0;
            width: 48mm;
            font-family: monospace;
            font-size: 11px;
            line-height: 1.3;

            }
          }

            body {
            width: 48mm;
            margin: 0 auto;
            font-family: monospace, sans-serif;
            font-size: 11px;
            line-height: 1.4;
            text-align: left;
            white-space: normal;
            word-break: keep-all;
            overflow-wrap: anywhere;
            }

          hr {
            border: 0;
            border-top: 1px dashed #000;
            margin: 1px 0;
          }

          p {
            margin: 1px 0;
            word-wrap: break-word;
            white-space: normal;
          }

          .bold {
            font-weight: bold;
          }
            
        .collegenameTitle, .affiliateTitle {
         display: block;
          font-size: 12px;
           font-weight: bold;
          text-align: start;
          word-break: break-word; /* allow wrapping */
        }
        </style>
        </head>
        <body>
        <!-- Header -->
      
      <h5 class="collegenameTitle" style="margin:0;">
             ${getCollegeTitle(paymentResponse?.studentsData?.lag?.display)}
        </h5>

        <hr />
        <p class="bold" style="margin:0;">PAYMENT RECEIPT</p>
        <hr />

        <!-- Payment Details -->
        <p>Date: ${formatDateTime(paymentResponse.created_at)}</p>
        <p>Receipt : ${paymentResponse.transaction_id}</p>
        <hr />
        <p>${paymentResponse.student}</p>
        ${paymentResponse?.studentsData?.profile_name === "Student" ? `
        <p>${paymentResponse?.studentsData?.gender === "Female"
                ? `D/O ${paymentResponse?.studentsData?.mother_name || "N/A"}`
                : `S/O ${paymentResponse?.studentsData?.father_name || "N/A"}`}</p>
        <p>${paymentResponse?.studentsData?.permanent_registration_number || ""}</p>
        ` : ""}
       <p style="word-wrap: break-word; white-space: normal;font-size:10px;">${paymentResponse?.studentsData?.lag?.display || ""}</p>

        <hr />
        <p>Amount  : ₹${paymentResponse?.amount?.toFixed(2)}</p>
        <p>Mode    : ${paymentResponse.payment_method}</p>
        <hr />
      </body>
      </html>
  `;


        const printWindow = window.open("", "_blank", "width=400,height=600");
        printWindow.document.open();
        printWindow.document.write(receiptHtml);
        printWindow.document.close();

        const cleanup = () => {
            printWindow.close();
            submitclose(); // Close the modal in all cases
            printWindow.removeEventListener("afterprint", cleanup);
        };

        printWindow.addEventListener("afterprint", cleanup);

        // Trigger print
        printWindow.focus();
        printWindow.print();

        // Fallback in case "afterprint" is not fired
        setTimeout(() => {
            if (!printWindow.closed) {
                cleanup();
            }
        }, 2000);
    };


    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Enter") {
                e.preventDefault();
                handlePrintReceipt();
            }
        };

        if (isOpen) {
            window.addEventListener("keydown", handleKeyDown);
        }

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen]);




    const handleShareReceipt = () => {
        const parentInfo = paymentResponse?.studentsData?.gender === "Female"
            ? `D/O ${paymentResponse?.studentsData?.mother_name || "N/A"}`
            : `S/O ${paymentResponse?.studentsData?.father_name || "N/A"}`;

        const receiptText = `
          Payment Receipt
             ------------------------
            College : ${getCollegeTitle(paymentResponse?.studentsData?.lag?.display)}

           Date    : ${formatDateTime(paymentResponse.created_at)}
          Receipt : ${paymentResponse.transaction_id}
           Student : ${paymentResponse.student}
               ${parentInfo}
              Reg No. : ${paymentResponse?.studentsData?.permanent_registration_number}
           Course  : ${paymentResponse?.studentsData?.lag?.display}
                 ------------------------
           Amount  : ₹${paymentResponse?.amount.toFixed(2)}
             Mode    : ${paymentResponse.payment_method}
              `;

        if (navigator.share) {
            if (navigator.canShare && navigator.canShare({ files: [] })) {
                // Mobile: share as a file
                const blob = new Blob([receiptText], { type: "text/plain" });
                const file = new File([blob], "PaymentReceipt.txt", { type: "text/plain" });

                navigator.share({
                    files: [file],
                    title: "Payment Receipt",
                    text: "Here is your payment receipt."
                }).catch(err => console.error("File share failed:", err));
            } else {
                // Desktop/mobile: fallback to just text share
                navigator.share({
                    title: "Payment Receipt",
                    text: receiptText
                }).catch(err => console.error("Text share failed:", err));
            }
        } else {
            // If Web Share API not supported at all
            navigator.clipboard.writeText(receiptText).then(() => {
                Notifier.success("Receipt copied to clipboard. You can paste it anywhere!");
            });
        }
    };



    return (
        <div className="modal-overlay">
            <div className="modal-content-success" style={{ position: 'relative', width: '30%' }}
                ref={trapRef}
            >
                <div className="modal-header-content" style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', marginBottom: '10px' }}>
                    <button className="close-btn" onClick={submitclose}><img src={close} alt="close" /></button>
                </div>

                <div ref={printRef}>
                    <div className="row justify-content-center" style={{ position: 'absolute', top: '-50px', right: '40%' }}>
                        <div className="col-md-12" style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                            <div style={{
                                width: '80px', height: '80px', borderRadius: '50%', background: '#fff',
                                boxShadow: "0px 6px 16px 0px #7A7A7A1F", display: 'flex', alignItems: 'center', justifyContent: 'center'
                            }}>
                                <img src={successgif} style={{ width: '60px', height: '60px' }} alt="success" />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12" style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                            <p style={{ color: '#7F56DA', fontWeight: '600', fontSize: '18px' }}>Payment Success!</p>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-md-12">
                            <p style={{ fontSize: '14px', margin: 0, textAlign: 'center' }}> Your payment has been successfully done.</p>
                        </div>
                        <div style={{ border: "1px solid #E8EAED", width: '159px', marginTop: '10px' }}></div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-12" style={{ display: 'flex', justifyContent: 'center' }}>
                            <p>Total Payment</p>
                        </div>
                    </div>
                    <div>
                        <p style={{ color: "#121212", fontSize: '24px', fontWeight: '600', marginTop: '15px', textAlign: 'center' }}>
                            INR {paymentResponse?.amount?.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                        </p>
                    </div>

                    <div className="row mt-2">
                        <div className="col-md-6">
                            <div style={{ border: "1px solid #EDEDED", padding: '6px 12px', borderRadius: '6px' }}>
                                <p className='sd-p'>Student Name</p>
                                <p className='alg-l'>{paymentResponse?.student}</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div style={{ border: "1px solid #EDEDED", padding: '6px 12px', borderRadius: '6px' }}>
                                <p className='sd-p'>Transaction ID</p>
                                <p className='alg-l'>{paymentResponse?.transaction_id}</p>
                            </div>
                        </div>
                    </div>

                    <div className='row mt-2'>
                        <div className="col-md-6">
                            <div style={{ border: "1px solid #EDEDED", padding: '6px 12px', borderRadius: '6px' }}>
                                <p className='sd-p'>Payment Mode</p>
                                <p className='alg-l'>{paymentResponse?.payment_method}</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div style={{ border: "1px solid #EDEDED", padding: '6px 12px', borderRadius: '6px' }}>
                                <p className='sd-p'>Payment Date</p>
                                <p className='alg-l'>{formatDateTime(paymentResponse?.created_at)}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ✅ Cancel Payment Button */}
                {/* {showCancelButton && (
                    <div className="row mt-4">
                        <div className="col-md-12 d-flex justify-content-center">
                            <button
                                className="btn btn-danger"
                                onClick={onCancelPayment}
                                style={{ padding: '8px 20px', borderRadius: '6px' }}
                            >
                                Cancel Payment
                            </button>
                        </div>
                    </div>
                )} */}
                <div className="row mt-3">
                    <div className="col-md-12 d-flex justify-content-around align-items-center" style={{ textAlign: 'center' }}>
                        <button
                            onClick={handlePrintReceipt}
                            style={{
                                backgroundColor: '#7F56DA',
                                border: 'none',
                                borderRadius: '6px',
                                padding: '8px 16px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                marginRight: '8px'
                            }}
                            onKeyDown={(e) => e.key === "Enter" && handlePrintReceipt()}

                        >
                            <img src={print} alt="print" style={{ marginRight: '8px' }} />
                            Print & New
                        </button>

                        {/* <button
                            onClick={handleShareReceipt}
                            style={{
                                backgroundColor: '#4CAF50',
                                border: 'none',
                                borderRadius: '6px',
                                padding: '8px 16px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                cursor: 'pointer'
                            }}
                        >
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="18" cy="6" r="3" stroke="white" strokeWidth="2" />
                                <circle cx="6" cy="12" r="3" stroke="white" strokeWidth="2" />
                                <circle cx="18" cy="18" r="3" stroke="white" strokeWidth="2" />
                                <path d="M8.5 13.5L15.5 16.5" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                <path d="M8.5 10.5L15.5 7.5" stroke="white" strokeWidth="2" strokeLinecap="round" />
                            </svg> Share
                        </button> */}
                    </div>
                </div>

            </div>
        </div>
    );
};
